import { certificateRoutes } from "../../constants/Routes";
const axios = require("axios");

export const parseEvidences = async (credential_no) => {
	try {
		let response = await axios.post(certificateRoutes.evidenceParse, {
			credential_no,
		});
		return response.data.result;
	} catch (error) {
		console.log(error);
		return [];
	}
};

export const parsePreviewEvidences = async (deliveryId) => {
	try {
		let response = await axios.post(certificateRoutes.parsePreviewEvidences, {
			deliveryId,
		});
		return response.data.result;
	} catch (error) {
		console.log(error);
		return [];
	}
};

export const getMemberLink = async (certificateNo) => {
	try {
		let response = await axios.post(certificateRoutes.getMemberLink, {
			certificateNo: certificateNo,
		});
		let responseJson = response.data;
		return responseJson.data;
	} catch (error) {
		console.log(error);
	}
};
